export const vpBoxShadow = '0px 4px 15.9px -7px rgba(0, 0, 0, 0.25)';

export enum VpBorderRadius {
  SMALL = '4px',
  MEDIUM = '12px',
  LARGE = '16px',
  XLARGE = '50px',
}
